import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Accordion from "../../../UiKit/Accordion/Accordion";
import stl from "./SpecsSection.module.css";
var SpecsSection = function SpecsSection(_ref) {
  var _specs$items;
  var selectedOptions = _ref.selectedOptions,
    isAutos = _ref.isAutos,
    specs = _ref.specs;
  var _useState = useState(null),
    openedAccordionIndex = _useState[0],
    setOpenedAccordionIndex = _useState[1];
  var handelToggle = function handelToggle(index) {
    setOpenedAccordionIndex(index === openedAccordionIndex ? null : index);
  };
  var isYearSelected = selectedOptions.find(function (option) {
    return option.filterField === "year";
  });
  useEffect(function () {
    return function () {
      setOpenedAccordionIndex(null);
    };
  }, [selectedOptions]);
  if (!isYearSelected || !isAutos || !specs) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("h2", null, specs === null || specs === void 0 ? void 0 : specs.title), specs === null || specs === void 0 ? void 0 : (_specs$items = specs.items) === null || _specs$items === void 0 ? void 0 : _specs$items.map(function (item, index) {
    var _item$sub_items, _item$sub_items2;
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      isOpen: index === openedAccordionIndex,
      onClick: function onClick() {
        return handelToggle(index);
      },
      headTitle: item === null || item === void 0 ? void 0 : item.title
    }, item !== null && item !== void 0 && (_item$sub_items = item.sub_items) !== null && _item$sub_items !== void 0 && _item$sub_items.length ? item === null || item === void 0 ? void 0 : (_item$sub_items2 = item.sub_items) === null || _item$sub_items2 === void 0 ? void 0 : _item$sub_items2.map(function (subItem, subIndex) {
      return /*#__PURE__*/React.createElement("div", {
        key: subIndex,
        className: stl.subWrapper
      }, /*#__PURE__*/React.createElement("h4", null, subItem === null || subItem === void 0 ? void 0 : subItem.title), /*#__PURE__*/React.createElement("p", null, subItem === null || subItem === void 0 ? void 0 : subItem.desc));
    }) : /*#__PURE__*/React.createElement("p", null, item === null || item === void 0 ? void 0 : item.desc));
  }));
};
export default SpecsSection;